module.exports = __webpack_public_path__ + "static/media/25.25718063.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/25.jpg
// module id = 200
// module chunks = 0